module.exports = __webpack_public_path__ + "static/media/Vamp3.8a982084.png";